(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['__config', '$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'CompanyInfoQuery', 'PushNotificationService', 'DeviceService', '$location', '$localStorage'];

    function LoginController(__config, $rootScope, $state, $timeout, Auth, $uibModalInstance, CompanyInfoQuery, PushNotificationService, DeviceService, $location, $localStorage) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.rememberMe = false;
        vm.__config = __config;


        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {

            event.preventDefault();
            if (vm.username != null && vm.username != undefined) {
                vm.username = vm.username.toLowerCase();

            }
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                captchaCode: vm.captchaCode
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();

                var currentCompany = null;
                $rootScope.$broadcast('authenticationSuccess');
                $rootScope.$broadcast('resetToggleSideMenu');

                CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                    if (company != null && company != undefined) {
                        currentCompany = company;
                        if (company.status != "ACTIVE") {
                            PushNotificationService.initPushNotification()
                            if (company.appVersion && company.appVersion == 'v3')
                                $state.go('supplierPanel-v2.companySubscriptionStatusV2');
                            else
                                $state.go('supplierPanel.companySubscriptionStatusV2');
                            return;
                        }

                        if (!company.title) {
                            $state.go('initSetupWizardV2');
                            return;
                        }


                    }

                    if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                        $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                        $state.current.name === 'home' || $state.current.name == 'activeUserAccount' ||
                        $state.current.name === 'createUserAccount' ||
                        $state.current.name === 'confirmSubscription' ||
                        $state.current.name === 'resetPasswordByPhoneNumber'

                    ) {
                        PushNotificationService.initPushNotification()
                        if (currentCompany && currentCompany.appVersion && currentCompany.appVersion == 'v3')
                            $state.go('supplierPanel-v2.dashboard');
                        else
                            $state.go('supplierPanel.dashboard');
                        return;
                    }


                })

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (response) {

                if (response.status == '423') {
                    $uibModalInstance.dismiss('cancel');
                    $state.go('activeUserAccount', {userName: vm.username});
                }
                vm.authenticationError = true;
            });
        }

        function register() {
            var type = ''
            if($localStorage.isNativeApp == "true"){
                type = "android"
            }
            $uibModalInstance.dismiss('cancel');
            $state.go('createUserAccount', { referralCode: type });

        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            //$state.go('requestReset');
            $state.go('resetPasswordByPhoneNumber');
        }
    }
})();
